import React, { useEffect, useState } from 'react'
import StartAssessmentIcon from '../../app/components/svgIcons/StartAssessmentIcon'
import { StyledLabel } from '../../assets/styledComponents/Global'
import styled from 'styled-components';
import StyledButton from '../../app/components/styledComponents/StyledButton';
import WarningFilledIcon from '../../app/components/svgIcons/WarningFilledIcon';
import { useWindowSize } from '../../utils/helper';
import moment from 'moment';
import CompanyInfoSideBar from './CompanyInfoSideBar';
import theme from '../../utils/themes';
import StyledCheckbox from '../../app/components/checkbox/StyledCheckbox';

const StartInterviewScreen = ({ data, setStartAssessment, buttonText, onButtonClick, componentTitle, companyInfo, icon, component = 'VP', description1, description2, description3, info1, infoBold, info2
}) => {
  const isSmallScreen = useWindowSize();
  useEffect(() => {
    localStorage.setItem('companyInfo', JSON.stringify(companyInfo));
    localStorage.setItem('component', JSON.stringify(component));
  }, [companyInfo]);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCheck, setIsCheck] = useState(false)
  return (
    <div className={`d-flex bg-body`}>
      {isSmallScreen && sidebarOpen && (<Overlay onClick={() => setSidebarOpen(false)} />)}
      {!isSmallScreen && <CompanyInfoSideBar component={component} background={component !== 'VP' ? theme?.bodyBg : ''} companyInfo={component === 'Referee' || component === 'RefereeForm' ? data : companyInfo} />}
      <div className={`d-flex flex-column flex-grow-1 p-2 gap-2`}>

        <div className={`bg-white p-3 mb-2 d-flex ${'justify-content-center'}  align-items-center`}>

          <StyledLabel size="20px" fontWeight="400" color={theme?.darktext} className="mb-3 font-fredoka fw-normal">
            {component === 'VP' ? data?.videoApplication?.videoProfile?.title || 'Video Profile Title' : componentTitle}
          </StyledLabel>
        </div>

        <div className='d-flex bg-white  justify-content-center align-items-center flex-column text-center p-3 overflow-y-auto ' style={{ minHeight: `calc(100vh - ${isSmallScreen ? '160px' : '102px'})` }}>
          {component === 'VP' ? <StartAssessmentIcon /> : icon}

          <StyledLabel
            size="22px"
            fontWeight="600"
            color={theme?.primary}
            className="mt-3"
          >{component === 'VP' ? 'Congratulations!' : data?.name}</StyledLabel>


          <StyledLabel
            size="16px"
            fontWeight="600"
            color={theme?.darktext}
            className="mt-3"
          >{component === 'VP' ? 'You have made it to our video profile phase of our interview process' : description1}</StyledLabel>

          {component === 'Referee' ? <StyledLabel
            size="15px"
            fontWeight="500"
            color={theme?.subText}
            className={`mt-3 ${isSmallScreen ? 'w-100' : 'w-50'} text-center`}
          > {description2}</StyledLabel> : ''}

          <StyledLabel
            size="16px"
            fontWeight="600"
            color={theme?.darktext}
            className="mt-3"
          >{component === 'VP' ? 'This is your chance to showcase your skills and personality directly to our hiring team.' : description3}</StyledLabel>

          {component === 'VP' ? <StyledLabel

            size="15px"
            fontWeight="600"
            color={theme?.subText}
            className={`mt-3 ${isSmallScreen ? 'w-100' : 'w-50'} text-center`}
          >{` ${data?.videoApplication?.videoProfile?.startDescription ? data?.videoApplication?.videoProfile?.startDescription : 'You’ll record short video responses to the questions provided, with full guidance before you start. Before recording, you’ll receive step-by-step instructions and can test your camera and microphone.'} `}</StyledLabel> : ''}


          {component === 'VP' && <StyledLabel
            size="15px"
            fontWeight="500"
            color={theme?.subText}
            className={`my-2 ${isSmallScreen ? 'w-100' : 'w-50'} text-center`}
          >


            Please note that retaking an answer will erase the previous one.
          </StyledLabel>}

          <InfoBox className={component !== 'VP' ? 'mt-4' : ''}>




            {component !== 'VP' ?
              <StyledCheckbox
                size={15}
                value={isCheck}
                className='border-secondary mt-1'
                align
                labelClassName="fw-bold text-muted border-primary"
                label={<StyledLabel size="14px" fontWeight={"500"} color={theme?.subText}>{info1} 
                <StyledLabel size="14px" fontWeight="600" color={theme?.primary} >{infoBold}</StyledLabel>{info2} </StyledLabel>}
                onChange={() => setIsCheck(!isCheck)}
              /> :
              <>
              <div className='bg-white d-flex justify-content-center align-items-center' style={{ width: 28, height: 28, borderRadius: '50%', lineHeight: 0, flexShrink: 0 }}>
                <WarningFilledIcon size={20} color={theme?.secondary} />
              </div>
            <StyledLabel
              size="14px"
              fontWeight={"500"}
              color={theme?.subText}

            >This video profile assessment expires in <StyledLabel
              size="14px"
              fontWeight="600"
              color={theme?.primary}
            >{ moment(data?.videoApplication?.expireAt).fromNow(true) + " (" + moment(data?.videoApplication?.expireAt).format("Do MMM, h:mm A") + ")."}</StyledLabel>{'For questions and any query, feel free to contact us here at' +
              <a
                className="text-primaryIcon text-decoration-none"
                href={'mailto:support@occy.com'}
              >
                Support@occy.com{' '}
              </a>} </StyledLabel>
              </>}
          </InfoBox>

          <StyledButton
            variant="primary"
            disabled={component !== 'VP' && !isCheck}
            className="mt-4 px-5"
            onClick={() => { component === 'VP' ? setStartAssessment(true) : onButtonClick() }}
          >
            {component === 'VP' ? 'Start Assessment' : buttonText}
          </StyledButton>
          {isSmallScreen && <StyledButton
            variant="white"
            className="mt-2"
            onClick={() => window.open("/p/video-profile/job-details", "_blank")}
          >
            View Job Details
          </StyledButton>}
        </div>
      </div>

    </div>
  )
}

export default StartInterviewScreen;

const InfoBox = styled.div`
display: flex;
  padding: 15px;
  width: 100%;
  gap: 5px;
  max-width: 700px;
  background: ${({ theme }) => theme?.bodyBg};
  color: ${({ theme }) => theme?.subText};
  border-radius: 5px;
`;

// const CompanyInfoSideBar = styled.div`
// display:flex;
// flex-direction:column;
// width: 337px;
// height: 100%;
// padding-top: 40px;
// padding-right: 30px;
// padding-left: 27px;

// `


export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.4);
  z-index: 1040;
`;